import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SitesettingEndpoint, SocialEndpoint, Url } from "../../Type/BaseUrl";

const SitesettingService = createApi({
	reducerPath: "SitesettingService",
	baseQuery: fetchBaseQuery({
		baseUrl: Url,
	}),
	endpoints: (builder) => {
		return {
			siteContent: builder.query({
				query: () => {
					return {
						url: SitesettingEndpoint,
						method: "GET",
					};
				},
			}),
			socialContent: builder.query({
				query: () => {
					return {
						url: SocialEndpoint,
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useSiteContentQuery, useSocialContentQuery } = SitesettingService;
export default SitesettingService;
